import React, { Component } from "react";
import ModalCustom from "../ModalCustom";
import ClaroParagraph from "../../atoms/ClaroParagraph";
import ClaroButton from "../../atoms/ClaroButton";
import ClaroCard from "../ClaroCard";
import { validateUserAgent } from "../../organisms/utils";

class DomiciliationModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, icon, message, subject, buttons, handleOnClick } =
      this.props;
    return (
      <ModalCustom isOpen={isOpen}>
        <ClaroCard
          padding="30px 16px 32px"
          style={{
            marginTop: "auto",
            marginLeft: "16px",
            marginRight: "16px",
            bottom: validateUserAgent() === "android" ? "0px" : "11%",
            position: "absolute",
          }}
        >
          <img
            src={icon}
            alt={""}
            width={"64px"}
            style={{ margin: "0px auto 25px" }}
          />
          <ClaroParagraph
            fontSize={"18px"}
            fontColor={"#0f0f0f"}
            fontFamily={"Amx-Bold"}
            align={"center"}
            margin={"0px 0px 16px 0px"}
            display=""
          >
            {subject || "Monto máximo por pago"}
          </ClaroParagraph>
          <ClaroParagraph
            fontSize={"16px"}
            fontColor={"#0f0f0f"}
            fontFamily={"Amx-Regular"}
            display=""
            margin={" 0px 8px 32px 8px"}
            align={"center"}
          >
            <section
              dangerouslySetInnerHTML={{ __html: message }}
              className="SearchResult-body"
            />
          </ClaroParagraph>
          <ClaroButton
            width={"80%"}
            margin={"0px auto"}
            padding={"0px"}
            $isValid={true}
            disabled={false}
            onClick={() => handleOnClick()}
          >
            {buttons[0] ? buttons[0] : "Entendido"}
          </ClaroButton>
        </ClaroCard>
      </ModalCustom>
    );
  }
}

export default DomiciliationModal;
